import type { ICard } from "../../cardsSlice";

export const cupsData: ICard[] = [
{
    id: "cups_1",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 1,
    name: "Туз Кубков",
    nameEn: "Ace of Cups",

    keywords: ["Любовь", "Эмоции", "Начало"],

    symbolism: [
      "Рука из облака держит кубок, из которого льётся вода",
      "Пять потоков",
      "Голубь с диском"
    ],
    symbolismInterpretation: "Источник любви и духовного наполнения",

    archetype: "Источник эмоций и вдохновения",
    psychology: "Открытость чувствам, готовность принять любовь",

    upright: {
      personality: "Чувствительность, доброта",
      relationships: "Новая любовь или возрождение отношений",
      work: "Проекты, связанные с вдохновением",
      spirituality: "Наполнение энергией любви",
      examples: ["Признание в любви", "Вдохновение", "Проявление заботы"]
    },
    reversed: {
      meaning: "Закрытость, эмоциональная пустота",
      nuances: "Подавленные чувства"
    },

    associations: ["Вода", "Голубь", "Исток"],
    combinations: [
      "С Десяткой Кубков — гармония в семье",
      "С Тузом Жезлов — любовь и страсть вместе"
    ],
    readingTips: [
      "Открыться новым эмоциям",
      "Ценить проявления любви"
    ],
    selfQuestions: [
      "Готов ли я принять любовь?",
      "Что наполняет моё сердце?"
    ]
  },
{
    id: "cups_2",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 2,
    name: "Двойка Кубков",
    nameEn: "Two of Cups",

    keywords: ["Союз", "Партнёрство", "Привязанность"],

    symbolism: [
      "Мужчина и женщина обмениваются кубками",
      "Кадуцей с львиной головой",
      "Взаимный взгляд"
    ],
    symbolismInterpretation: "Гармония и единение двух сторон",

    archetype: "Партнёрство, союз",
    psychology: "Желание близости и доверия",

    upright: {
      personality: "Гармоничность, открытость",
      relationships: "Любовь, крепкий союз",
      work: "Сотрудничество, равноправное партнёрство",
      spirituality: "Осознание единства",
      examples: ["Союз", "Перемирие", "Дружба"]
    },
    reversed: {
      meaning: "Разрыв, непонимание",
      nuances: "Нарушение гармонии"
    },

    associations: ["Кадуцей", "Лев", "Союз"],
    combinations: [
      "С Влюблёнными — крепкая связь",
      "С Тройкой Мечей — болезненный разрыв"
    ],
    readingTips: [
      "Ценить взаимность",
      "Работать над доверием"
    ],
    selfQuestions: [
      "Что я готов дать партнёру?",
      "Как я строю гармоничные отношения?"
    ]
  },
{
    id: "cups_3",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 3,
    name: "Тройка Кубков",
    nameEn: "Three of Cups",

    keywords: ["Праздник", "Дружба", "Поддержка"],

    symbolism: [
      "Три женщины поднимают кубки",
      "Плоды и цветы у ног",
      "Танец"
    ],
    symbolismInterpretation: "Радость, дружеское общение, совместные успехи",

    archetype: "Дружеский круг",
    psychology: "Потребность в социальном взаимодействии и радости",

    upright: {
      personality: "Общительность, позитив",
      relationships: "Дружба, празднование",
      work: "Успех команды",
      spirituality: "Осознание силы объединения",
      examples: ["Вечеринка", "Поддержка", "Общий успех"]
    },
    reversed: {
      meaning: "Изоляция, поверхностные связи",
      nuances: "Зависть в кругу друзей"
    },

    associations: ["Танец", "Фрукты", "Радость"],
    combinations: [
      "С Четвёркой Жезлов — праздник по поводу успеха",
      "С Пятёркой Кубков — разочарование в компании"
    ],
    readingTips: [
      "Разделять радость",
      "Поддерживать друзей"
    ],
    selfQuestions: [
      "Кто в моём кругу приносит радость?",
      "Как я отмечаю успехи?"
    ]
  },
{
    id: "cups_4",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 4,
    name: "Четвёрка Кубков",
    nameEn: "Four of Cups",

    keywords: ["Скука", "Апатия", "Размышления"],

    symbolism: [
      "Человек сидит под деревом, отвернувшись от кубка, который предлагает рука из облака",
      "Три кубка на земле",
      "Сосредоточенное лицо"
    ],
    symbolismInterpretation: "Закрытость новым предложениям, сосредоточенность на внутреннем мире",

    archetype: "Интроверт, медитирующий на жизнь",
    psychology: "Недовольство имеющимся, поиск смысла",

    upright: {
      personality: "Созерцательность, отрешённость",
      relationships: "Нежелание принимать инициативу",
      work: "Отсутствие интереса",
      spirituality: "Уход в себя",
      examples: ["Медитация", "Потеря интереса"]
    },
    reversed: {
      meaning: "Открытие новым возможностям",
      nuances: "Пробуждение интереса"
    },

    associations: ["Дерево", "Облако", "Созерцание"],
    combinations: [
      "С Восьмёркой Кубков — уход на поиски большего",
      "С Тузом Жезлов — пробуждение"
    ],
    readingTips: [
      "Замечать возможности",
      "Не застревать в апатии"
    ],
    selfQuestions: [
      "Что я упускаю из виду?",
      "Чем я могу оживить свой интерес?"
    ]
  },
{
    id: "cups_5",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 5,
    name: "Пятёрка Кубков",
    nameEn: "Five of Cups",

    keywords: ["Потеря", "Сожаление", "Печаль"],

    symbolism: [
      "Человек в чёрном плаще смотрит на три опрокинутых кубка",
      "Два кубка позади",
      "Река и мост"
    ],
    symbolismInterpretation: "Фокус на потере вместо возможностей",

    archetype: "Скорбящий",
    psychology: "Неспособность отпустить прошлое",

    upright: {
      personality: "Сентиментальность, печаль",
      relationships: "Разрыв, разочарование",
      work: "Неудача проекта",
      spirituality: "Урок через утрату",
      examples: ["Разрыв отношений", "Потеря шанса"]
    },
    reversed: {
      meaning: "Принятие, переход к новому",
      nuances: "Осознание оставшихся возможностей"
    },

    associations: ["Мост", "Река", "Опустошение"],
    combinations: [
      "С Двойкой Кубков — попытка восстановить отношения",
      "С Звездой — надежда после утраты"
    ],
    readingTips: [
      "Замечать, что осталось",
      "Учиться отпускать"
    ],
    selfQuestions: [
      "На чём я зациклился?",
      "Что ещё у меня есть?"
    ]
  },
{
    id: "cups_6",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 6,
    name: "Шестёрка Кубков",
    nameEn: "Six of Cups",

    keywords: ["Воспоминания", "Детство", "Щедрость"],

    symbolism: [
      "Ребёнок даёт цветы другому ребёнку",
      "Шесть кубков с цветами",
      "Старинный город"
    ],
    symbolismInterpretation: "Связь с прошлым, ностальгия, чистота намерений",

    archetype: "Детская радость",
    psychology: "Теплые воспоминания и желание восстановить простоту",

    upright: {
      personality: "Доброта, щедрость",
      relationships: "Возвращение старых связей",
      work: "Обращение к прошлому опыту",
      spirituality: "Исцеление через память",
      examples: ["Встреча с прошлым", "Ностальгия"]
    },
    reversed: {
      meaning: "Застревание в прошлом",
      nuances: "Отказ смотреть вперёд"
    },

    associations: ["Цветы", "Дети", "Ностальгия"],
    combinations: [
      "С Шестёркой Жезлов — успех, связанный с прошлым",
      "С Повешенным — зависание в воспоминаниях"
    ],
    readingTips: [
      "Беречь лучшие воспоминания",
      "Не забывать о настоящем"
    ],
    selfQuestions: [
      "Что я беру из прошлого?",
      "Что мешает мне жить настоящим?"
    ]
  },
{
    id: "cups_7",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 7,
    name: "Семёрка Кубков",
    nameEn: "Seven of Cups",

    keywords: ["Иллюзии", "Выбор", "Фантазии"],

    symbolism: [
      "Человек перед семью парящими кубками",
      "В кубках фигуры: драгоценности, венец, змея, замок, призрак, дьявол, лавры",
      "Облака и туман"
    ],
    symbolismInterpretation: "Множество соблазнов и вариантов, риск заблудиться в мечтах",

    archetype: "Мир фантазий и искушений",
    psychology: "Сложность приоритизации, уход от реальности",

    upright: {
      personality: "Воображение, мечтательность",
      relationships: "Нереалистичные ожидания",
      work: "Разброс внимания, множество идей",
      spirituality: "Поиск видений, но нужна проверка реальностью",
      examples: ["Иллюзорные цели", "Трудный выбор", "Туманность намерений"]
    },
    reversed: {
      meaning: "Прояснение, сокращение вариантов",
      nuances: "Возврат к конкретике, выбор одного пути"
    },

    associations: ["Облака", "Мираж", "Соблазн"],
    combinations: [
      "С Тузом Мечей — трезвое прояснение вариантов",
      "С Дьяволом — самообман и зависимость от фантазий"
    ],
    readingTips: [
      "Отделять желаемое от возможного",
      "Сузить выбор до 1–2 приоритетов"
    ],
    selfQuestions: [
      "Какая опция действительно ведёт вперёд?",
      "Где я путаю мечты с планом?"
    ]
  },
{
    id: "cups_8",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 8,
    name: "Восьмёрка Кубков",
    nameEn: "Eight of Cups",

    keywords: ["Уход", "Поиск смысла", "Отпускание"],

    symbolism: [
      "Фигура уходит от восьми кубков",
      "Луна над горами",
      "Камнистая тропа"
    ],
    symbolismInterpretation: "Сознательный уход от привычного к более глубокому смыслу",

    archetype: "Странник в поиске истины",
    psychology: "Насыщение старым опытом, потребность в новом этапе",

    upright: {
      personality: "Зрелость, решительность отпустить",
      relationships: "Пауза или разрыв ради роста",
      work: "Смена направления карьеры",
      spirituality: "Паломничество, внутренняя дорога",
      examples: ["Уход из токсичной среды", "Переезд", "Поиск призвания"]
    },
    reversed: {
      meaning: "Возврат к пройденному, страх перемен",
      nuances: "Застревание из-за привязанности"
    },

    associations: ["Ночь", "Дорога", "Прощание"],
    combinations: [
      "С Отшельником — глубокий внутренний путь",
      "С Миром — завершение поиска"
    ],
    readingTips: [
      "Чётко назвать причину ухода",
      "Подготовить ресурсную поддержку"
    ],
    selfQuestions: [
      "Что я перерастал(а)?",
      "Куда зовёт внутренний голос?"
    ]
  },
{
    id: "cups_9",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 9,
    name: "Девятка Кубков",
    nameEn: "Nine of Cups",

    keywords: ["Удовлетворение", "Исполнение желаний", "Достаток"],

    symbolism: [
      "Человек сидит перед девятью кубками на полке",
      "Скрещённые руки и довольная улыбка",
      "Праздничная обстановка"
    ],
    symbolismInterpretation: "Личное удовлетворение, сбыча желаний, эмоциональный комфорт",

    archetype: "Желанное исполнено",
    psychology: "Самодостаточность, гордость результатом",

    upright: {
      personality: "Уверенность, щедрость",
      relationships: "Тёплая атмосфера, наслаждение близостью",
      work: "Заслуженная награда",
      spirituality: "Благодарность за прожитое",
      examples: ["Малые праздники", "Личный успех", "Исполнение просьбы"]
    },
    reversed: {
      meaning: "Излишества, пустое самолюбование",
      nuances: "Желания исполняются, но не радуют"
    },

    associations: ["Пир", "Комфорт", "Награда"],
    combinations: [
      "С Шестёркой Жезлов — публичный успех",
      "С Умеренностью — здоровое наслаждение без излишеств"
    ],
    readingTips: [
      "Разделить радость с другими",
      "Не переходить грань в гедонизм"
    ],
    selfQuestions: [
      "Что для меня истинное удовлетворение?",
      "Чем я готов(а) делиться?"
    ]
  },
{
    id: "cups_10",
    arcana: "minor",
    suit: "cups",
    court: "simple",
    number: 10,
    name: "Десятка Кубков",
    nameEn: "Ten of Cups",

    keywords: ["Гармония", "Семья", "Завершённость"],

    symbolism: [
      "Пара и дети под радугой из десяти кубков",
      "Дом и холмы",
      "Жест благодарности к небу"
    ],
    symbolismInterpretation: "Эмоциональное единство, семейная гармония, счастливый финал цикла",

    archetype: "Дом как пристанище сердца",
    psychology: "Чувство принадлежности и поддержки",

    upright: {
      personality: "Доброжелательность, миролюбие",
      relationships: "Семейная идиллия, союз",
      work: "Командная сплочённость",
      spirituality: "Благодарность и единение",
      examples: ["Свадьба", "Примирение", "Семейный праздник"]
    },
    reversed: {
      meaning: "Семейные трения, несбывшиеся ожидания",
      nuances: "Внешняя картинка без внутреннего согласия"
    },

    associations: ["Радуга", "Дом", "Единство"],
    combinations: [
      "С Четвёркой Жезлов — тёплое торжество",
      "С Тройкой Мечей — семейная драма"
    ],
    readingTips: [
      "Поддерживать гармонию",
      "Не пренебрегать внутренними проблемами"
    ],
    selfQuestions: [
      "Что для меня семья?",
      "Как я поддерживаю близких?"
    ]
  },
{
    id: "cups_11",
    arcana: "minor",
    suit: "cups",
    court: "page",
    number: 11,
    name: "Паж Кубков",
    nameEn: "Page of Cups",

    keywords: ["Эмоциональная открытость", "Творчество", "Интуиция"],

    symbolism: [
      "Юноша держит кубок с появившейся рыбкой",
      "Море на фоне",
      "Нежные цвета одежды"
    ],
    symbolismInterpretation: "Открытие к новым чувствам, творческое вдохновение",

    archetype: "Посланник эмоций",
    psychology: "Игривость, восприимчивость к знакам",

    upright: {
      personality: "Мягкость, мечтательность",
      relationships: "Нежная симпатия",
      work: "Творческое предложение",
      spirituality: "Принятие интуитивных инсайтов",
      examples: ["Неожиданное признание", "Художественная идея"]
    },
    reversed: {
      meaning: "Незрелость в чувствах",
      nuances: "Отрыв от реальности"
    },

    associations: ["Рыба", "Море", "Нежность"],
    combinations: [
      "С Пажом Жезлов — эмоциональное и творческое начало",
      "С Луной — сильная интуиция"
    ],
    readingTips: [
      "Замечать тонкие знаки",
      "Доверять вдохновению"
    ],
    selfQuestions: [
      "Что пробуждает моё воображение?",
      "Готов ли я показать свои чувства?"
    ]
  },
{
    id: "cups_12",
    arcana: "minor",
    suit: "cups",
    court: "knight",
    number: 12,
    name: "Рыцарь Кубков",
    nameEn: "Knight of Cups",

    keywords: ["Романтика", "Идеализм", "Предложение"],

    symbolism: [
      "Всадник в доспехах держит кубок",
      "Река и горы",
      "Крылатый шлем и сапоги"
    ],
    symbolismInterpretation: "Поход за мечтой, романтическое предложение",

    archetype: "Идеалист",
    psychology: "Следование за эмоциональным импульсом",

    upright: {
      personality: "Очарование, мягкость",
      relationships: "Романтический жест",
      work: "Проект, вдохновлённый чувствами",
      spirituality: "Поиск красоты и гармонии",
      examples: ["Свидание", "Признание", "Путь художника"]
    },
    reversed: {
      meaning: "Неискренность, бегство от реальности",
      nuances: "Слишком высокие ожидания"
    },

    associations: ["Конь", "Река", "Любовь"],
    combinations: [
      "С Влюблёнными — романтическое признание",
      "С Семёркой Кубков — идеализация"
    ],
    readingTips: [
      "Сохранять реализм в чувствах",
      "Быть честным с собой и другими"
    ],
    selfQuestions: [
      "Что я готов предложить?",
      "Какая мечта ведёт меня?"
    ]
  },
{
    id: "cups_13",
    arcana: "minor",
    suit: "cups",
    court: "queen",
    number: 13,
    name: "Королева Кубков",
    nameEn: "Queen of Cups",

    keywords: ["Сострадание", "Интуиция", "Глубокие чувства"],

    symbolism: [
      "Женщина с закрытым кубком на троне у моря",
      "Морские мотивы",
      "Нежные цвета"
    ],
    symbolismInterpretation: "Глубокая эмоциональная мудрость, интуиция",

    archetype: "Хранительница чувств",
    psychology: "Чуткость, эмпатия",

    upright: {
      personality: "Сострадательность, забота",
      relationships: "Глубокая связь",
      work: "Поддержка, заботливое руководство",
      spirituality: "Слушание внутреннего голоса",
      examples: ["Эмпатия", "Терапия", "Интуитивный совет"]
    },
    reversed: {
      meaning: "Эмоциональная нестабильность",
      nuances: "Манипуляция чувствами"
    },

    associations: ["Море", "Раковина", "Сердце"],
    combinations: [
      "С Верховной Жрицей — мощная интуиция",
      "С Луной — эмоциональная глубина"
    ],
    readingTips: [
      "Доверять чувствам",
      "Беречь эмоциональные границы"
    ],
    selfQuestions: [
      "Как я забочусь о других?",
      "Какие чувства я скрываю?"
    ]
  },
{
    id: "cups_14",
    arcana: "minor",
    suit: "cups",
    court: "king",
    number: 14,
    name: "Король Кубков",
    nameEn: "King of Cups",

    keywords: ["Уравновешенность", "Мудрость", "Сострадание"],

    symbolism: [
      "Мужчина с кубком и скипетром",
      "Трон в море",
      "Корабли и дельфин"
    ],
    symbolismInterpretation: "Контроль над эмоциями при глубокой чуткости",

    archetype: "Мудрый наставник",
    psychology: "Эмоциональная зрелость",

    upright: {
      personality: "Сдержанность, благородство",
      relationships: "Поддержка и защита",
      work: "Дипломатия",
      spirituality: "Сочетание разума и сердца",
      examples: ["Миротворец", "Терапевт", "Учитель"]
    },
    reversed: {
      meaning: "Подавленные эмоции, пассивная агрессия",
      nuances: "Использование знаний во вред"
    },

    associations: ["Море", "Корабль", "Сострадание"],
    combinations: [
      "С Справедливостью — честный суд",
      "С Повешенным — жертва ради других"
    ],
    readingTips: [
      "Сохранять эмоциональный баланс",
      "Быть открытым, но с границами"
    ],
    selfQuestions: [
      "Как я контролирую свои эмоции?",
      "Кому я могу быть опорой?"
    ]
  }
];


